import styles from "./YuJaNavbar.module.css";
import { ReactComponent as YuJaLogo } from "../images/yujalogo.svg";
import { ReactComponent as NavbarArrow } from "../images/navbar_arrow_purple.svg";
import { ReactComponent as LogOut } from "../images/LogoutIcon.svg";
import { ReactComponent as Setting } from "../images/SettingNavibarIcon.svg";
import { ReactComponent as Support } from "../images/SupportIcon.svg";
import { ReactComponent as NewWindowIconBlue } from "../images/links/new_window_blue.svg";
import {useHistory, useLocation} from "react-router-dom";
import {useLocalStorageNew} from "../hooks/useLocalStorageNew";
import {useCookie} from "../hooks/useCookie";
import React, {useEffect, useState} from "react";
import {
    ACCOUNT_CARD_LOGOUT_TEXT,
    ACCOUNT_CARD_SETTING_TEXT,
    ACCOUNT_CARD_SUPPORT_TEXT, BUTTON, CREATE_POLL_PATH, GRADED_POLL,
    HOME_ICON,
    MENU_LIST,
    NAVBAR_ENGAGE, OPEN_IN_NEW_TAB, RESPONSIVE_SIDE_BAR_POINT,
    ROLES, YUJA_SUPPORT_LINK
} from "../utils/constants";
import {NavDropdown} from "react-bootstrap";
import {roleValuetoDisplay} from "../utils/helpers";
import {AuthenticationApiCalls} from "../apis/AuthenticationApiCalls";
import {YuJaTooltip} from "./standardization/YuJaTooltip";

import ResponsiveSidebar from "./ResponsiveSidebar";
import layoutStyles from "../layouts/Layout.module.css";
import NewSidebar from "./NewSidebar";
import useWindowDimensions from "../hooks/useWindowDimensions";
import ProfileIcon from "./ProfileIcon";
import {useSession} from "../hooks/useSession";
export default function YuJaNavbarNew({ isViewer = false, isCreator = false, countdownContent, webSocketState, pollKeyCode, pollType, pageIdentifier }) {
    const history = useHistory();
    const location = useLocation();
    const [, getSession] = useLocalStorageNew("session", {});
    const [, getCookie] = useCookie("name", "Guest");
    const {parseSessionToken} = useSession();
    const { logout } = AuthenticationApiCalls();
    let { width} = useWindowDimensions();
    const isNarrow = width <= RESPONSIVE_SIDE_BAR_POINT;
    const session = getSession();
    const [collapsed, setCollapsed] = useState(true);
    const [showLogoutBtn, setShowLogoutBtn] = useState(!!session.userName);
    const [pinCode, setPinCode] = useState("");
    const anonymous = !session.userName;
    let userName;
    if (anonymous) {
        userName = getCookie();
    } else {
        if (session.firstName && session.lastName) {
            userName = session.firstName + " " + session.lastName;
        } else if (session.firstName) {
            userName = session.firstName;
        } else {
            userName = session.userName;
        }
    }
    let email = session.email;
    let role = session.role
    let names = userName.split(" ");

    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }

    const sideNavbarStyle = {
        position: "absolute",
        left: "0px",
        top: "0px",
        minWidth: isNarrow ? "240px" : "60px",
        zIndex: 2,
        overflowX: "hidden",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
        height: "100vh",
    };



    const onClickLogo = () => {
        if (!!session.gradedLink) {
            return;
        }
        history.push("/home");
    }

    const logoutFunction = () => {
        if (window.location.pathname.startsWith(MENU_LIST.CREATE.path) || window.location.pathname.startsWith(MENU_LIST.CREATE.altPath)) {
            history.push({
                pathname: CREATE_POLL_PATH,
                state: {pollType: GRADED_POLL, fromNavbar: true, previous: CREATE_POLL_PATH, logout: true}
            })
        }
        else {
            logout();
        }
    }

    useEffect(() => {
        let payLoad = parseSessionToken();
        if (!!payLoad) {
            const {pinCode=""} = payLoad;
            setPinCode(!!pinCode ? pinCode : "");
        }
    }, []);

    return (
        <div id="viewer-navbar-container" className={`${styles.navBarContainer} ${isNarrow ? styles.responsiveNavBarContainer : ""}`} >
            {!isNarrow &&
                <>
                    <div
                        tabIndex={0}
                        aria-label={HOME_ICON}
                        className={`${styles.logoContainer} ${!session.gradedLink ? styles.clickable : ""}`}
                        onClick={onClickLogo}
                    >
                        <YuJaLogo width={24} height={24}/>
                    </div>
                    <span className={styles.pathContainer}>
                        {NAVBAR_ENGAGE}
                            {location.pathname !== MENU_LIST.HOME.path &&
                                <>
                                    <NavbarArrow height={15}/>
                                    {pageIdentifier}
                                </>
                            }
                    </span>
                </>
            }

            {!!isNarrow &&
                <ResponsiveSidebar
                    className={`${layoutStyles.LeftSideBarContainer}`}
                    sidebarStyle={sideNavbarStyle}
                    // setShowSideBar={setShowSideBar}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                >
                    <NewSidebar sideBarCollapseAble={false} isViewer={isViewer} isCreator={isCreator} isMobile={true} collapsed={collapsed} setCollapsed={setCollapsed} />
                </ResponsiveSidebar>
            }
            <div style={{flex: 1, minWidth: 0, height: "100%"}}>
                {countdownContent}
            </div>
            {window.location !== window.parent.location &&
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    {isNarrow &&
                        <YuJaTooltip text={OPEN_IN_NEW_TAB} placement="bottom">
                            <NewWindowIconBlue
                                aria-label={OPEN_IN_NEW_TAB}
                                role={BUTTON}
                                style={{width: 28, height: 28, cursor: "pointer", marginRight: 5}}
                                onMouseDown={e => e.preventDefault()}
                                onClick={() => {
                                    const engageSession = encodeURIComponent(JSON.stringify(getSession()));
                                    const path = window.location.pathname;
                                    const dest = encodeURIComponent(path.includes(CREATE_POLL_PATH) && pollKeyCode ? `/edit/${pollKeyCode}` : path);
                                    const pollTypeParam = encodeURIComponent(pollType ? pollType : "");
                                    window.open(`/portal?engageSession=${engageSession}&dest=${dest}${`&pollType=${pollTypeParam}`}`);
                                }}
                            />
                        </YuJaTooltip>
                    }
                    {!isNarrow &&
                        <YuJaTooltip text={OPEN_IN_NEW_TAB} placement="bottom">
                            <NewWindowIconBlue
                                aria-label={OPEN_IN_NEW_TAB} role={BUTTON}
                                style={{width: 28, height: 28, cursor: "pointer", marginRight: 5}}
                                onMouseDown={e => e.preventDefault()}
                                onClick={() => {
                                    const engageSession = encodeURIComponent(JSON.stringify(getSession()));
                                    const path = window.location.pathname;
                                    const dest = encodeURIComponent(path.includes(CREATE_POLL_PATH) && pollKeyCode ? `/edit/${pollKeyCode}` : path);
                                    const pollTypeParam = encodeURIComponent(pollType ? pollType : "");
                                    window.open(`/portal?engageSession=${engageSession}&dest=${dest}${`&pollType=${pollTypeParam}`}`);
                                }}
                            />
                        </YuJaTooltip>
                    }
                </div>
            }


            <NavDropdown
                className = {"navDropdown"}
                title={(
                    <div
                        className={"navbar-unit"}
                        style={{
                            position: "relative",
                            display: "flex",
                            justifyContent: "end",
                            width: "100%",
                            height: "100%"
                        }}
                    >
                        <span className="navDropdownText" style={{display: "flex", alignItems: "center"}}>
                            <ProfileIcon
                                size={33}
                                initialLetter={initials[0] ? initials[0] : "G"}
                            />
                            {webSocketState === WebSocket.CONNECTING &&
                                <div style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: "#b0b0b0",
                                    position: "absolute",
                                    left: "calc(100% - 10px)",
                                    top: "calc(100% - 10px)"
                                }}/>
                            }
                            {webSocketState === WebSocket.OPEN &&
                                <div style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: "#008400",
                                    position: "absolute",
                                    left: "calc(100% - 10px)",
                                    top: "calc(100% - 10px)"
                                }}/>
                            }
                            {webSocketState === WebSocket.CLOSED &&
                                <div style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: "#B40030",
                                    position: "absolute",
                                    left: "calc(100% - 10px)",
                                    top: "calc(100% - 10px)"
                                }}/>
                            }
                        </span>
                    </div>

                )}
            >
                <div style={{position: "relative", right: 20, width: "100px", cursor: "initial"}}>
                    <ul role="menu"
                        style={{
                            boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 5px 0px",
                            padding: "8px 0px",
                            position: "absolute",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            width: 180,
                            height: "fit-content"
                        }}
                    >
                        <ProfileIcon
                            size={45}
                            initialLetter={initials[0] ? initials[0] : "G"}
                            style={{ margin: 10}}
                        />
                        <div
                            title={userName}
                            style={{
                                textAlign: "center", fontWeight: 700, maxWidth: "175px",
                                fontSize: 20, lineHeight: 1.4, overflow: "hidden", whiteSpace: "nowrap",
                                textOverflow: "ellipsis", paddingLeft: "10px", paddingRight: "10px"
                            }}
                        >{userName} </div>
                        <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.6,}}>
                            {roleValuetoDisplay(role)}
                        </div>
                        <div
                            title={email}
                            style={{
                                overflow: "hidden", maxWidth: "175px",
                                textOverflow: "ellipsis", whiteSpace: "nowrap",
                                fontSize: "14px", lineHeight: 1.6, paddingLeft: "10px", paddingRight: "10px"
                            }}
                        > {email} </div>
                        {!!pinCode &&
                            <div style={{color: "#6F6F6F", fontSize: "14px", lineHeight: 1.6,}}>
                                {`PIN: ${pinCode}`}
                            </div>
                        }


                        <hr style={{width: "100%", margin: "10px 0"}}/>
                        <NavDropdown.Item tabIndex={0} onClick={() => window.open(YUJA_SUPPORT_LINK)}
                                          style={{fontSize: "15px", display: "flex"}}>
                            <span style={{display: "flex", alignItems: "center", gap: 10, width: 150}}><Support
                                size={24} style={{width: 24, height: 24}}/>{ACCOUNT_CARD_SUPPORT_TEXT}</span>
                        </NavDropdown.Item>
                        {!anonymous && !session.gradedLink && <>
                            <NavDropdown.Item tabIndex={0} onClick={() => {
                                history.push({
                                    pathname: role === ROLES.VIEWER.value ? "/student/settings" : "/admin/platformsetting",
                                    state: {User: true}
                                });
                            }} style={{fontSize: "15px", display: "flex", marginTop: 10}}>
                                <span style={{display: "flex", alignItems: "center", gap: 10, width: 150}}><Setting
                                    size={24} style={{width: 24, height: 24}}/>{ACCOUNT_CARD_SETTING_TEXT}</span>
                            </NavDropdown.Item>
                        </>}
                        {!anonymous && showLogoutBtn && <>
                            <hr style={{width: "100%", margin: "10px 0"}}/>
                            <NavDropdown.Item tabIndex={0} onClick={logoutFunction}
                                              style={{fontSize: "15px", display: "flex"}}>
                                <span style={{display: "flex", alignItems: "center", gap: 10, width: 150}}><LogOut
                                    size={24} style={{width: 24, height: 24}}/>{ACCOUNT_CARD_LOGOUT_TEXT}</span>
                            </NavDropdown.Item>
                        </>}
                    </ul>
                </div>
            </NavDropdown>
        </div>
    );
}